import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { CourseCatalogPostingStream } from 'app/library/course-catalog-landing-page/models/course-catalog-posting-stream.model';
import { CourseCatalogService } from 'app/library/course-catalog/services/course-catalog.service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';

@Component({
    selector: 'app-catalog-offerings-dialog',
    templateUrl: './catalog-offerings-dialog.component.html',
    styleUrls: ['./catalog-offerings-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class CatalogOfferingsDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    postingResource: CourseCatalogPostingStream;

    constructor(
        public dialogRef: MatDialogRef<CatalogOfferingsDialogComponent>,
        public tenantDataService: TenantDataService,
        private _router: Router,
        private _courseCatalogService: CourseCatalogService
    ) {
        super();
    }

    ngOnInit(): void {}

    openPostingUrl() {
        this.dialogRef.close();

        if (this.postingResource.url.includes(window.location.host)) {
            const relativePath = new URL(this.postingResource.url).pathname;

            if (this.postingResource.kind === 'course_category') {
                const categoryId = relativePath.split('/').filter(Boolean).pop();
                if (categoryId) {
                    this._courseCatalogService.setSelectedCategoryId(categoryId);
                }
            }

            void this._router.navigateByUrl(relativePath);
            return;
        }

        window.open(`${this.postingResource.url}`, '_self');
    }
}
